import React, { useEffect } from 'react';
import { Card, ListGroup, Accordion, Badge, Button, Dropdown, ButtonGroup } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { useCompanyNavigation } from '../../utils/Hooks/useCompanyNavigation';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../Pages.css';

const CustomToggle = ({ children, eventKey }) => {
  //const decoratedOnClick = useAccordionButton(eventKey, () => console.log( eventKey + 'Custom Toggle Clicked'));
  const decoratedOnClick = useAccordionButton(eventKey);
  
  return (
    <Card.Header onClick={decoratedOnClick} style={{ cursor: 'pointer' }}>
      {children}
    </Card.Header>
  );
};

export const ActivityCard = ({ activity, eventKey, loading, editActivity, closeActivity }) => {
  const toCompany = useCompanyNavigation();
  const Mailto = ({ email, children }) => {
    return <a className="mailto-link" href={`mailto:${email}`}>{children}</a>;
  };

  const Telto = ({ phone, children }) => {
    return <a className="telto-link" href={`telto:${phone}`}>{children}</a>;
  };

  //useEffect(() => {
  //  console.log(eventKey);
  //}, [eventKey]);



  return (
    <Accordion defaultActiveKey="0">
      <Card>
        <CustomToggle eventKey={eventKey}>
          <Card.Title className={activity.Status === 'OPEN' ? activity.DueInDays < 0 ? 'pastdue' : activity.DueInDays === 0 ? 'duetoday' : null : 'closed'}>
            <div className='company-title-grid'>
              <div className='activity-title-group-1'>
                {activity.Title}
              </div>
              {/*{activity.ActivityCreatorID !== activity.ActivityForID ? */}
              {/*<div className='activity-title-group-2'>*/}
              {/*  <Badge bg="secondary">{activity.ActivityCreatorName}</Badge>*/}
              {/*</div> : null}*/}

              {!!activity.IsAssociated ?
                <div className='activity-title-group-3'>
                  {activity.Status === 'OPEN' ?
                    <>
                      {/*
                      <Button
                        variant="success"
                        disabled={loading}
                        style={{ borderRadius: "10px" }}
                        onClick={(e) => closeActivity(e, activity, 0)}
                        className='m-2'>
                        <span className="me-2">
                          <i className="bi bi-check-lg"></i>
                        </span>
                        Done
                      </Button>
                      */}

                      <Button
                        variant='success'
                        style={{ borderRadius: "10px" }}
                        onClick={(e) => { if (e) {e.preventDefault(); e.stopPropagation();closeActivity(e, activity, 0)}}}
                        className='m-2'>
                          Done
                      </Button>

                      <Button
                        variant="danger"
                        disabled={loading}
                        style={{ borderRadius: "10px" }}
                        onClick={(e) => closeActivity(e, activity, 1)}
                        className='m-2'>
                        <span className="me-2">
                          <i className="bi bi-x-lg"></i>
                        </span>
                        Cancel
                      </Button>
                    </>
                    : null}
                  {activity.Status === 'CANCELED' || activity.Status === 'CLOSED' ?
                    <>
                      <Button
                        variant="success"
                        disabled={loading}
                        style={{ borderRadius: "10px" }}
                        onClick={(e) => closeActivity(e, activity, 4)}
                        className='m-2'>
                        <span className="me-2">
                          <i className="bi bi-alarm"></i>
                        </span>
                        Add a Follow-Up
                      </Button>
                  </>
                    : null}
                  <Button
                    variant="warning"
                    disabled={loading}
                    style={{ borderRadius: "10px" }}
                    onClick={(e) => editActivity(e, activity)}
                    className='m-2'>
                    <span className="me-2">
                      <i className="bi bi-pencil"></i>
                    </span>
                    Edit
                  </Button>
                </div>
                : null}
            </div>
          </Card.Title>

        </CustomToggle>
        <Accordion.Collapse eventKey={eventKey}>
          <Card.Body>
            <div className='card-grid'>
              <div className='card-item-1'>
                <ListGroup className="list-group-flush">
                  <ListGroup.Item>
                    <div className='text-row'>
                      <div className='card-bold'>Company</div>
                      <div className='card-text'><a className='company-link' href='#' onClick={() => toCompany(activity.CompanyID)}>{activity.CompanyName}</a><Badge className="activity-company-badge" bg="secondary">{'Sales Rep: ' + activity.CompanySalesRepName}</Badge></div>

                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Contact</div><div className='card-text'>{activity.IndividualName}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Title</div><div className='card-text'>{activity.IndividualTitle}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'>
                    <div className='card-bold'>Email</div>
                    <div className='card-text'>
                      <Mailto email={activity.IndividualEmail}>{activity.IndividualEmail}</Mailto>
                    </div>
                  </div>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className='text-row'>
                      <div className='card-bold'>Phone</div>
                      <div className='card-text'>
                        <Telto phone={activity.IndividualPhone}>{activity.IndividualPhone}</Telto>
                      </div>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className='text-row'>
                      <div className='card-bold'>Cell</div>
                      <div className='card-text'>
                        <Telto phone={activity.IndividualCell}>{activity.IndividualCell}</Telto>
                      </div>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Address</div> <div className='card-text'>{activity.CompanyAddress}</div></div></ListGroup.Item>
                </ListGroup>
              </div>
              <div className='card-item-2'>
                <ListGroup className="list-group-flush">
                  {activity.ActivityCreatorID !== activity.ActivityForID ?
                    <ListGroup.Item><div className='text-row'><div className='card-bold'>Created By</div><div className='card-text'>{activity.ActivityCreatorName}</div></div></ListGroup.Item>
                    : null}
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Assigned To</div><div className='card-text'>{activity.ActivityForName}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Activity Type</div><div className='card-text'>{activity.TypeName}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Activity Date</div> <div className='card-text'>{activity.StartDateFormatted}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Recurs</div> <div className='card-text'>{activity.FollowUpRecurrenceText}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Notes</div> <div className='card-text'>{activity.ActivityComments}</div></div></ListGroup.Item>
                </ListGroup>
              </div>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
};